import { render, staticRenderFns } from "./SignUpPage.vue?vue&type=template&id=54fe8c18&scoped=true"
import script from "./SignUpPage.vue?vue&type=script&lang=ts"
export * from "./SignUpPage.vue?vue&type=script&lang=ts"
import style0 from "./SignUpPage.vue?vue&type=style&index=0&id=54fe8c18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fe8c18",
  null
  
)

export default component.exports